import { request } from '@/api/request'


export const getAllOSTs = async () => {
  const { data } = await request.get(`/webapi/good/all/ost`)

  return data.value;
}

export const getUserOwnedOSTs = async () => {
  const { data } = await request.get(`/webapi/good/me/owned/ost`)

  return data.value;
}

export const createDownloadTokenOST = async (ostId: string) => {
  const { data } = await request.post(`/webapi/good/me/tokens/${ostId}/create`)

  return data.value;
}